import BaseRepository from "../../../common/repository/base_repository";
import SecondFactorLoginModel from "../model/second_factor_login_model";

export default class SecondFactorLoginRepository extends BaseRepository {

    itemUrl = '/api/login/second-factor';
    modelClass = SecondFactorLoginModel;

}